// extracted by mini-css-extract-plugin
export default {"snow":"SnowEffect_snow__tuC+x","flake":"SnowEffect_flake__Od-5t","fall":"SnowEffect_fall__lkjTK","sway":"SnowEffect_sway__tjZ1U"};